define('components/Search/SearchComponent',[
	'core/can',
	'text!components/Search/SearchView.stache',
	'jquery-throttle'
], function(can, template) {
	
	can.Component.extend({
		
		tag: 'ax-search',
		
		template: template,
		
		scope: { 
			_hideClear: can.compute(function() {
				return this.attr('searchvalue') === undefined || this.attr('searchvalue').length <= 0;
			})
		},

		events: {
			
			'.form-control keydown': $.debounce(500, function(el, ev) {
				el.trigger('change');
			}),

			'.clear click': function(el, ev) {
				this.scope.attr('searchvalue', '');
			}

		}
	});
	
});
